import { DateTime } from "luxon";

export const getUserTimeZoneId = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const getUsersTimeZone = () => {
    const zoneId = DateTime.local().zoneName;
    const dateTime = DateTime.now().setZone(zoneId);

    const zoneName = dateTime.toFormat("z"); // gives "Europe/Berlin"
    const offset = dateTime.toFormat("ZZ"); // gives "+02:00"

    return `${zoneName} (UTC ${offset})`;
};

// Builds a timezone abbreviation label (e.g. "AEST", "EDT") from an ISO datetime string with offset.
// Parsed the same way as the booking "When" displayText (browser zone) so the abbreviation always
// matches the shown time, including DST at the appointment date. Falls back to a "GMT+10"-style
// label when the browser locale has no abbreviation for the zone.
export const getTimeZoneAbbreviation = (isoWithOffset?: string | null): string | null => {
    if (!isoWithOffset) return null;

    const dateTime = DateTime.fromISO(isoWithOffset);
    if (!dateTime.isValid) return null;

    // Not toFormat("ZZZZ"): toFormat redefaults to en-US when no locale is configured, ignoring
    // the browser locale — an AU browser would get "GMT+10" instead of "AEST".
    return dateTime.offsetNameShort;
};
